import styled from 'styled-components';
import { styledHeader, Typography } from './BaseTypes';
import { styledMargin } from '../layout/Margin';

export const H1 = styled.h1<Typography>`
  ${styledHeader}
  ${styledMargin}
  font-size: 60px;
`;
